import React from 'react';
import PropTypes from 'prop-types';

import './Hero.sass';

export default function Hero({title, subtitle, children}) {
  return (
    <div className="hero">
      <div className="hero__row">
        <div className="hero__content">
          <div className="hero__subheader">{subtitle}</div>
          <h1 className="hero__header">{title}</h1>
          <div className="hero__buttons">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

Hero.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired
};




// WEBPACK FOOTER //
// ./components/hero/Hero.js